import { render, staticRenderFns } from "./PlaceLabelEditForm.vue?vue&type=template&id=45e07120"
import script from "./PlaceLabelEditForm.vue?vue&type=script&lang=js"
export * from "./PlaceLabelEditForm.vue?vue&type=script&lang=js"
import style0 from "./PlaceLabelEditForm.vue?vue&type=style&index=0&id=45e07120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports